module.exports = __webpack_public_path__ + "media/7.59f37cb8.mp3";